module.exports = __webpack_public_path__ + "img/07_uk.ee291a97.svg";